import React, { useEffect, useState } from "react";
import { Form, Table, Alert, Image, Modal } from "react-bootstrap";
import {
  organizerAddSponsorApi,
  organizerUpdateSponsorApi,
  organizerListSponsorsApi,
  organizerDeleteSponsorApi,
  organizerListEventsApi,
} from "../../api/api";

import { handleError } from "../../helpers/handleError";
import SpinLoading from "../../components/spinLoading/SpinLoading";
import OrganizerPillSelect from "../components/OrganizerPillSelect";
import "../dashboard.css";

const Sponsors = () => {
  const [events, setEvents] = useState([]);
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [form, setForm] = useState({ name: "", eventid: "", image: null });
  const [edit, setEdit] = useState({ show: false, id: null, name: "", eventid: "", image: null });

  const load = async () => {
    setLoading(true);
    try {
      const [ev, sp] = await Promise.all([organizerListEventsApi(), organizerListSponsorsApi()]);
      setEvents(Array.isArray(ev?.data?.info) ? ev.data.info : []);
      setList(Array.isArray(sp?.data?.info) ? sp.data.info : []);
    } catch (e) {
      handleError(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const onCreate = async (e) => {
    e.preventDefault();
    setError("");
    try {
      if (!form.image) return setError('La imagen es obligatoria');
      const fd = new FormData();
      fd.append('name', form.name);
      fd.append('eventid', form.eventid);
      fd.append('image', form.image);
      await organizerAddSponsorApi(fd);
      setForm({ name: "", eventid: "", image: null });
      await load();
    } catch (err) {
      console.error(err);
      setError(err?.response?.data?.message || 'Error al crear patrocinador');
    }
  };

  const onDelete = async (id) => {
    if (!window.confirm('¿Eliminar patrocinador?')) return;
    try {
      setLoading(true);
      await organizerDeleteSponsorApi({ id });
      await load();
    } catch (e) { handleError(e); } finally { setLoading(false); }
  };

  const onOpenEdit = (s) => {
    const eventValue = s?.eventid?._id || s?.eventid || '';
    setEdit({ show: true, id: s._id, name: s.name, eventid: eventValue ? String(eventValue) : '', image: null });
  };

  const onSaveEdit = async () => {
    try {
      setLoading(true);
      const fd = new FormData();
      fd.append('id', edit.id);
      fd.append('name', edit.name);
      if (edit.eventid) fd.append('eventid', edit.eventid);
      if (edit.image) fd.append('image', edit.image);
      await organizerUpdateSponsorApi(fd);
      setEdit({ show: false, id: null, name: '', eventid: '', image: null });
      await load();
    } catch (e) { handleError(e); alert(e?.response?.data?.message || 'Error updating'); } finally { setLoading(false); }
  };
  if (loading) return <SpinLoading />;
  return (
    <div className="organizer-page">
      <section className="organizer-section">
      <div className="organizer-section__header">
        <div>
          <p className="organizer-eyebrow">Branding</p>
          <h2>Patrocinadores del evento</h2>
          <p className="organizer-section__subtitle">Subí logos y relacioná cada sponsor con su evento.</p>
        </div>
      </div>
      {error && <Alert variant="danger" className="mb-3">{error}</Alert>}
      <div className="organizer-form-grid">
        <div className="organizer-form-card">
          <h3>Agregar patrocinador</h3>
          <Form onSubmit={onCreate}>
            <Form.Control
              className="organizer-field"
              placeholder="Nombre"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              required
            />
            <Form.Control
              className="organizer-field"
              type="file"
              accept="image/*"
              onChange={(e) => setForm({ ...form, image: e.target.files?.[0] || null })}
            />
            <OrganizerPillSelect
              placeholder="Selecciona evento"
              value={form.eventid}
              onChange={(val) => setForm({ ...form, eventid: val ? String(val) : "" })}
              options={events
                .map((ev) => {
                  const raw = ev?.id ?? ev?._id ?? ev?.eventid;
                  if (!raw) return null;
                  return { value: String(raw), label: ev?.name || "Evento sin nombre" };
                })
                .filter(Boolean)}
            />
            <div className="organizer-form-actions">
              <button type="submit" className="organizer-btn">Crear</button>
            </div>
          </Form>
        </div>
      </div>
      <div className="organizer-card">
        <div className="organizer-card__header">
          <div>
            <h3 className="organizer-card__title">Patrocinadores cargados</h3>
            <p className="organizer-card__subtitle">Mostramos todos los sponsors asignados a tus eventos.</p>
          </div>
          <div className="organizer-chip organizer-chip--secondary">{list.length} registros</div>
        </div>
        <div className="organizer-table">
          <Table responsive className="organizer-table__inner align-middle">
            <thead>
              <tr>
                <th>Imagen</th>
                <th>Nombre</th>
                <th>Evento</th>
                <th>Estado</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {list.map((s) => (
                <tr key={s._id}>
                  <td>{s.image && <Image src={s.image} alt={s.name} thumbnail style={{ maxHeight: 40 }} />}</td>
                  <td>{s.name}</td>
                  <td>{s.eventname || '-'}</td>
                  <td>
                    <span className={`organizer-chip ${s.status ? "organizer-chip--success" : "organizer-chip--secondary"}`}>
                      {s.status ? "Activo" : "Inactivo"}
                    </span>
                  </td>
                  <td>
                    <button type="button" className="organizer-link-btn" onClick={() => onOpenEdit(s)}>Editar</button>
                    <button type="button" className="organizer-link-btn danger ms-3" onClick={() => onDelete(s._id)}>Eliminar</button>
                  </td>
                </tr>
              ))}
              {list.length === 0 && (<tr><td colSpan={5} className="text-center text-muted py-3">Sin patrocinadores</td></tr>)}
            </tbody>
          </Table>
        </div>
      </div>
      <Modal show={edit.show} onHide={() => setEdit({ ...edit, show: false })}>
        <Modal.Header closeButton><Modal.Title>Editar patrocinador</Modal.Title></Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Label>Nombre</Form.Label>
            <Form.Control className="mb-2" value={edit.name} onChange={(e) => setEdit({ ...edit, name: e.target.value })} />
            <Form.Label>Evento</Form.Label>
            <OrganizerPillSelect
              placeholder="Selecciona evento"
              value={edit.eventid}
              onChange={(val) => setEdit({ ...edit, eventid: val ? String(val) : "" })}
              options={events
                .map((ev) => {
                  const raw = ev?.id ?? ev?._id ?? ev?.eventid;
                  if (!raw) return null;
                  return { value: String(raw), label: ev?.name || "Evento sin nombre" };
                })
                .filter(Boolean)}
            />
            <Form.Label>Reemplazar imagen</Form.Label>
            <Form.Control type="file" accept="image/*" onChange={(e) => setEdit({ ...edit, image: e.target.files?.[0] || null })} />
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="organizer-btn secondary" onClick={() => setEdit({ ...edit, show: false })}>Cancelar</button>
          <button type="button" className="organizer-btn" onClick={onSaveEdit}>Guardar</button>
        </Modal.Footer>
      </Modal>
      </section>
    </div>
  );
};

export default Sponsors;
